/**
 * API Configuration Utility
 * 
 * CRITICAL FIX: Always use window.location.origin for production stability.
 * This ensures the app works on ANY domain (preview, production, custom domains).
 * 
 * The same-origin approach is the most reliable because:
 * 1. No CORS issues
 * 2. No hardcoded URLs that can become stale
 * 3. Works on any deployed domain automatically
 * 
 * The REACT_APP_BACKEND_URL is only used for local development when
 * frontend and backend run on different ports.
 */

const getBaseUrl = () => {
  // For local development (localhost), use env variable if set
  const isLocalhost = window.location.hostname === 'localhost' || 
                      window.location.hostname === '127.0.0.1';
  
  if (isLocalhost && process.env.REACT_APP_BACKEND_URL) {
    return process.env.REACT_APP_BACKEND_URL;
  }
  
  // For ALL deployed environments (preview, production, custom domains),
  // ALWAYS use current origin - this is the safest approach
  return window.location.origin;
};

export const API_BASE_URL = getBaseUrl();
export const API_URL = API_BASE_URL + '/api';

// Debug logging only in development
if (process.env.NODE_ENV === 'development') {
  console.log('[API Config] Base URL:', API_BASE_URL);
  console.log('[API Config] API URL:', API_URL);
}

export default API_URL;
